import { render, staticRenderFns } from "./salesTerritoryManage.vue?vue&type=template&id=8515e7ac&scoped=true"
import script from "./salesTerritoryManage.vue?vue&type=script&lang=js"
export * from "./salesTerritoryManage.vue?vue&type=script&lang=js"
import style0 from "./salesTerritoryManage.vue?vue&type=style&index=0&id=8515e7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8515e7ac",
  null
  
)

export default component.exports